<template>
	<div id="app-shop">
		<!-- 목록 -->
		<div class="content board-list">
			<div class="container">

				<!-- 페이지 타이틀 -->
				<div class="page-title">
					<h2 class="tit">{{ PAGE_TITLE }}</h2>
				</div>

				<div class="list-controls">
					<form @submit.prevent="doSearch">

<!--						<div class="tab swiper-container m-b-10" v-if="!$options.filters.isEmpty( params.WISH_LIKE )">-->
<!--							<ul class="swiper-wrapper">-->
<!--								<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'edu') }">-->
<!--									<a href="javascript:;" @click="setStatus('edu')">교육</a>-->
<!--								</li>-->
<!--								<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'board') }">-->
<!--									<a href="" @click="setStatus('board')">게시글</a>-->
<!--								</li>-->
<!--								<li class="swiper-slide" :class="{ 'active': (params.STATUS === 'shop') }">-->
<!--									<a href="javascript:;" @click="setStatus('shop')">상품</a>-->
<!--								</li>-->
<!--							</ul>-->
<!--						</div>-->

						<!-- 필터 -->
						<code-selector @getItem="getGoodsList" cateCode="10" :codeNameList="JSON.stringify(codeNameList)" v-if="$options.filters.isEmpty( params.WISH_LIKE )"></code-selector>

						<!-- 검색 -->
						<div class="search">
							<p class="total">총 <span>{{ goodsCount | currency }}</span>개의 게시물이 있습니다.</p>
							<div class="search-form">
								<input class="inp-search" id="" name="" type="text" placeholder="검색어를 입력하세요" v-model="search">
								<button class="btn-search" type="submit"></button>
							</div>
						</div>
					</form>
				</div>
				<!-- 리스트 -->
				<list :goods-list="goodsList" :import-list="importList" @goGoodsOne="goView"></list>

				<!-- 버튼 -->
				<div class="btn-area" v-if="goodsList.length < goodsCount">
					<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import List from "@/components/shop/goods/goodsList";
import CodeSelector from "@/components/selectors/codeSelector";

export default {
	name: "appShop",
	components: {CodeSelector, List},
	data() {

		var params = this.pageUtils.Params()
		if (this.webUtils.getParameterInt("idx") > 0) {
			params.idx = this.webUtils.getParameterInt("idx");
		}
		// params.size = 8;
		// if( params.WISH_LIKE !== null){
		// 	params.STATUS = ( this.webUtils.getParameter("STATUS") === "" ) ? "shop" : this.webUtils.getParameter("STATUS");
		// }

		return {
			params,

			PAGE_TITLE : "상품 리스트",

			pageCount: 15,
			goodsVO: {},
			goodsCount: 0,
			goodsList: [],
			importList: [],
			search: '',
      codeNameList: ['brandCode', 'makerCode', 'cateCode']
		}
	},
	created() {
    this.initSearchText()
    this.getGoodsList();
	},
	mounted() {

	},
	methods: {
    initSearchText() {
      if (this.params.searchText !== "" && this.params.searchText != null) {
        this.search = this.params.searchText
        $('#app-shop').children('.inp-search').val(this.params.searchText)
      }
    },
		getGoodsList() {

			let URL = this.APIs.SHOP_GOODS + "/";
			// if ( this.$route.params.WISH_LIKE != null ) {
			//
			// 	temp.WISH_LIKE = this.$route.params.WISH_LIKE
			// 	URL += "getGoodsWishLikeList";
			//
			// 	switch (this.$route.params.WISH_LIKE) {
			// 		case "wish":
			// 			this.PAGE_TITLE = "관심목록";
			// 			break;
			// 		case "like":
			// 			this.PAGE_TITLE = "좋아요";
			// 			break;
			// 		default:
			// 			this.PAGE_TITLE = "상품 리스트";
			// 			break;
			// 	}
			// }

			this.params.brandCode = this.$route.query.brandCode;
			this.params.makerCode = this.$route.query.makerCode;
			this.params.cateCode = this.$route.query.cateCode;

			this.axiosCaller.get(this, URL, {
				page: this.params.page,
				size: this.pageCount,
				sort: this.params.sort,
				searchText: this.search,
				brandCode: this.params.brandCode,
				makerCode: this.params.makerCode,
				cateCode: this.params.cateCode,
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					console.log('result', result)
					this.goodsList = result.list;
					this.goodsCount = result.totalCount;
					this.params.size = this.pageCount;

					//this.importList = result.importList;

					// this.getGoodsList();
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
		},

		// setStatus ( _status ) {
		//
		// 	this.params.STATUS = _status;
		// 	this.pageUtils.routerPush( this, this.params )
		//
		// 	console.log('_status',_status)
		//
		// 	if(_status==="shop"){
		// 		location.href = "/app/professional-services/design_auto_app/wish"
		// 	}else if(_status==="edu"){
		// 		location.href = "/app/education/mine/wish"
		// 	}else if(_status==="board"){
		// 		location.href = "/app/education/mine/wish"
		// 	}
		//
		// 	this.getGoodsList();
		// },

		doLoadMore() {
			// this.resetBoardOne();
			this.params.page++;

			this.$router.push({
				query: this.params,
			}).catch(() => {
			})

			this.getGoodsList();
		},

		doSearch() {
			// this.resetBoardOne();
			this.goodsList = [];
			this.params.page = 0;
			this.params.size = this.pageCount;
			this.params.searchText = this.search;

			this.$router.push({
				query: this.params,
			}).catch(() => {
			})

			this.getGoodsList();
		},

		goView(_idx) {
			this.params.idx = _idx
			// console.log( this.params )
			// this.pageUtils.pushState( this.params )
			this.$router.push({
				query: this.params,
			}).catch(() => {
			})
		},
	},
}
</script>

<style scoped>
</style>
